<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <divcard>
      <div class="card-part">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 1 :</span> ข้อมูลบริษัท/หน่วยงาน
        </div>
        <!-- Form 1 -->
        <div class="txt-head black--text mb-2">1. ข้อมูลบริษัท/หน่วยงาน</div>
        <!-- block 1 -->
        <div class="flex-center gap-16">
          <div class="flex">
            <div class="mb-1 black--text">ชื่อบริษัท (ภาษาไทย)</div>
            <TextField
              theme="3"
              :value="form.company_name_th"
              @onChange="
                form.company_name_th = $event;
                $forceUpdate();
              "
            >
            </TextField>
          </div>

          <div class="flex">
            <div class="mb-1 black--text">ชื่อบริษัท (ภาษาอังกฤษ)</div>
            <TextField
              theme="3"
              :value="form.company_name_en"
              @onChange="
                form.company_name_en = $event;
                $forceUpdate();
              "
            >
            </TextField>
          </div>
        </div>
        <!-- block 2 -->
        <div>
          <div class="mb-1 black--text">
            ที่อยู่สำนักงานใหญ่ (Head Office Address)
          </div>
          <TextField
            theme="3"
            :value="form.company_address"
            @onChange="
              form.company_address = $event;
              $forceUpdate();
            "
          >
          </TextField>
        </div>
        <!-- block 3 -->
        <div class="flex-center gap-16">
          <div class="flex">
            <div class="mb-1 black--text">รหัสไปรษณีย์ (Postal Code)</div>
            <TextField
              theme="3"
              input-type="number"
              :rules="zipCodeRules"
              :value="form.company_postal_code"
              @onChange="
                form.company_postal_code = $event;
                $forceUpdate();
              "
            >
            </TextField>
          </div>
          <div class="flex">
            <div class="mb-1 black--text">โทรศัพท์ (Telephone No.)</div>
            <TextField
              placeholder="09XXXXXXXX"
              theme="3"
              input-type="number"
              :value="form.company_phone"
              @onChange="
                form.company_phone = $event;
                $forceUpdate();
              "
            >
            </TextField>
          </div>
          <div class="flex">
            <div class="mb-1 black--text">โทรสาร (Facsimile No.)</div>
            <TextField
              theme="3"
              input-type="number"
              :value="form.company_fac"
              @onChange="
                form.company_fac = $event;
                $forceUpdate();
              "
            >
            </TextField>
          </div>
          <div class="flex">
            <div class="mb-1 black--text">อีเมล (E-mail)</div>
            <TextField
              theme="3"
              :rules="emailRules"
              :value="form.company_email"
              @onChange="
                form.company_email = $event;
                $forceUpdate();
              "
            >
            </TextField>
          </div>
        </div>
        <!-- block 4 -->
        <div>
          <div class="mb-1 black--text">เว็บไซต์ (Website)</div>
          <TextField
            :rules="websiteRules"
            theme="3"
            :value="form.company_website"
            @onChange="
              form.company_website = $event;
              $forceUpdate();
            "
          >
          </TextField>
        </div>
      </div>
    </divcard>
    <divcard>
      <div class="card-part pt-0">
        <div class="txt-head black--text d-flex justify-space-between mb-3">
          <div class="txt-head black--text mb-2">
            2. อัพโหลดภาพบริษัท (Company Picture)
          </div>

          <Button theme="6" @onClick="addAttachment"> + เพิ่มไฟล์ </Button>
        </div>

        <!-- Form 1 -->
        <div>
          <div class="theme-color-seven mb-3">
            *ไฟล์ที่ระบบรองรับ .PNG (สูงสุด 50 mb/ไฟล์)
          </div>

          <v-layout class="mt-3" v-for="(file, f) in attachment" :key="f">
            <template v-if="!file.doc_type || file.doc_type === null">
              <v-flex xs7>
                <v-file-input
                  v-model="files[f]"
                  :id="'file' + f"
                  :rules="rulesFile"
                  color="#F15A29"
                  :clearable="false"
                  style="border-radius: 30px"
                  outlined
                  height="36"
                  placeholder=""
                  prepend-icon=""
                  accept="image/png"
                  v-show="
                    checkValType(file.file_name) == 'object' ||
                    file.file_name == '' ||
                    file.file_name == null
                  "
                  @change="addToAttachment(files[f], f)"
                ></v-file-input>
                <v-text-field
                  v-show="checkValType(file.file_name) == 'string'"
                  v-model="file.file_name"
                  outlined
                  height="36"
                  color="#F15A29"
                  style="border-radius: 30px"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex shrink ml-3>
                <v-btn
                  depressed
                  dark
                  rounded
                  width="100"
                  color="#464647"
                  @click="selectFile(f)"
                >
                  <v-icon class="font-12 font-w-700" left>mdi-upload</v-icon>
                  <span class="font-12 font-w-700">อัพโหลด</span>
                </v-btn>
              </v-flex>
              <v-flex shrink ml-3>
                <v-btn
                  depressed
                  height="35"
                  width="35"
                  fab
                  dark
                  color="#FD0C0C"
                  @click="removeFile(f)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-flex>
            </template>
          </v-layout>
        </div>
      </div>
    </divcard>
    <divcard>
      <div class="txt-head black--text mb-2">
        3. คะแนนประเมิน (Evaluation score)
      </div>
      <spiderChart :masterData="masterData" />
    </divcard>
    <divcard>
      <div class="txt-head black--text mb-2">
        4. ความต้องการใช้พื้นที่ (Space requirements)
      </div>
      <div class="flex-center gap-16">
        <div class="flex">
          <div class="mb-1 black--text">พื้นที่ ที่ต้องการใช้งาน</div>
          <AutoBox
            theme="3"
            :items="masterData?.areaMasterRoomType"
            item-text="name"
            item-value="name"
            :value="form.space_needed"
            @onChange="handleSpaceNeededChange"
          />
        </div>
        <div class="d-flex gap-16">
          <div class="flex">
            <div class="mb-1 black--text">ชั้น</div>
            <AutoBox
              theme="3"
              :items="filteredFloors"
              item-text="name"
              item-value="name"
              :value="form.space_floor"
              :readonly="!form.space_needed"
              @onChange="handleSpaceFloorChange"
            />
          </div>
          <div class="flex">
            <div class="mb-1 black--text">ห้อง</div>
            <AutoBox
              theme="3"
              :items="filteredRooms"
              item-text="name"
              item-value="name"
              :value="form.space_room"
              :readonly="!form.space_floor || !form.space_needed"
              @onChange="handleSpaceRoomChange"
            />
          </div>
        </div>
      </div>
      <div class="flex-center gap-16">
        <div class="flex">
          <div class="mb-1 black--text">ขนาดพื้นที่</div>
          <TextField
            theme="3"
            input-type="number"
            :value="form.space_area_size"
            :readonly="true"
            :disabled="true"
            @onChange="
              form.space_area_size = $event;
              $forceUpdate();
            "
          >
          </TextField>
        </div>
      </div>
    </divcard>
    <divcard>
      <div class="txt-head black--text mb-2">
        5. รูปแบบการจัดตั้ง (Form of establishment)
      </div>
      <div>
        <div class="mb-1 black--text">
          รูปแบบการจัดตั้ง (Form of establishment)
        </div>
        <AutoBox
          theme="3"
          :items="masterData?.establishment"
          item-text="name"
          item-value="name"
          :value="form.space_type"
          @onChange="
            form.space_type = $event;
            $forceUpdate();
          "
        />
        <TextField
          v-if="form.space_type == 'อื่นๆ (ระบุ)'"
          theme="3"
          :value="form.space_type_other"
          @onChange="
            form.space_type_other = $event;
            $forceUpdate();
          "
        >
        </TextField>
      </div>
    </divcard>
    <divcard>
      <div class="txt-head black--text mb-2">
        6. จำนวนบุคลากร (Number of personnel)
      </div>
      <div>
        <div class="mb-1 black--text">จำนวนบุคลากร (Number of personnel)</div>
        <TextField
          theme="3"
          input-type="number"
          :value="form.number_of_person"
          @onChange="
            form.number_of_person = $event;
            $forceUpdate();
          "
        >
        </TextField>
      </div>
    </divcard>
    <divcard>
      <div class="txt-head black--text mb-2">
        7. ประเภทผู้ใช้บริการพื้นที่ (Type of service user)
      </div>
      <div>
        <div class="mb-1 black--text">ประเภทผู้ใช้บริการพื้นที่</div>
        <AutoBox
          theme="3"
          :items="masterData?.AreaMasterType"
          item-text="name"
          item-value="id"
          :value="form.area_type_id"
          :readonly="true"
          @onChange="
            form.area_type_id = $event;
            $forceUpdate();
          "
        />
        <divcard>
          <img
            v-if="selectedRoomData"
            :src="`${apiDomain}assets/images/rooms/${selectedRoomData?.region}/${getPrefixImageByRegion(selectedRoomData?.region)}_${selectedRoomData?.name}.jpg`"
            class="img-fluid"
            alt="Sample Image"
            @error="handleImageError"
          />
          <div v-else class="no-image">No Image</div>
        </divcard>
      </div>
    </divcard>
  </div>
</template>

<script>
import TextField from "../../components/input/TextField";
import SwitchInset from "../../components/input/SwitchInset";
import AutoBox from "../../components/input/AutoBox";
import Button from "@/components/input/Button";
import CheckBox from "../../components/input/CheckBox";
import DatePicker from "../../components/input/DatePicker";
import spiderChart from "./spiderChart.vue";
import { eventBus, validateEmail } from "../../plugins/global-funcs";
import { mapState } from "vuex";
import { apiDomain } from "@/store/constants";

export default {
  components: {
    TextField,
    SwitchInset,
    AutoBox,
    Button,
    CheckBox,
    DatePicker,
    spiderChart,
  },
  data() {
    return {
      apiDomain,
      type: [
        {
          name: "1",
          value: 1,
        },
        {
          name: "2",
          value: 2,
        },
        {
          name: "3",
          value: 3,
        },
      ],
      form: {},
      formFile: [],
      files: [],
      attachment: [{}],
      filteredFloors: [],
      filteredRooms: [],
      selectedRoomData: null,
      rulesFile: [
        (value) => !!value || "กรุณาแนบเอกสาร",
        (value) =>
          !value || value.size <= 50000000 || "ขนาดไฟล์ต้องน้อยกว่า 50 MB!",
      ],
      websiteRules: [
        (v) => !!v || "",
        (v) => /^(http|https):\/\/[^ "]+$/.test(v) || "เว็บไซต์ไม่ถูกต้อง",
      ],
      zipCodeRules: [
        (v) => !!v || "",
        (v) => (v && v.length === 5) || "รหัสไปรษณีย์ต้องมี 5 หลัก",
      ],
      emailRules: [
        (v) => !!v || "",
        (v) => validateEmail(v) || "อีเมลไม่ถูกต้อง",
      ],
      mobilePhoneRules: [
        (v) => !!v || "",
      ],
      pidRules: [
        (v) => !!v || "",
        (v) => (v && v.length === 13) || "เลขประจำตัวประชาชนต้องมี 13 หลัก",
      ],
    };
  },
  props: {
    masterData: Object,
    formData: Object,
  },
  watch: {
    formData: {
      handler(newValue) {
        this.form = JSON.parse(JSON.stringify(newValue));
        this.$nextTick(() => {
          this.setData();
        });
      },
      deep: true,
      immediate: true,
    },
    files: {
      handler(val) {
        this.formFile = this.attachment;
        console.log("this.form@watch", this.formFile);
      },
      deep: true,
    },
    form: {
      handler(newValue) {
        if (newValue?.space_type != "อื่นๆ (ระบุ)") {
          this.form.space_type_other = null;
        }
      },
      deep: true,
      immediate: true,
    },
    "form.space_needed": function (newVal, oldVal) {
      console.log("space_needed changed:", oldVal, "->", newVal);
      this.updateFilteredRooms();
    },
    "form.space_floor": function (newVal, oldVal) {
      console.log("space_floor changed:", oldVal, "->", newVal);
      this.updateFilteredRooms();
    },
    "masterData.areaMasterRoom": {
      handler: function (newVal) {
        console.log("masterData.areaMasterRoom changed");
        this.updateFilteredRooms();
      },
      deep: true,
    },
  },
  created() {
    eventBus.$on("spiderChart1", () => {
      eventBus.$emit("spiderChart1Send", {
        ...this.form,
        updated_by: "1",
        created_by: "1",
        attachments: this.formFile,
      });
    });
    eventBus.$emit("spiderChart1Send", {
      ...this.form,
      updated_by: "1",
      created_by: "1",
      attachments: this.formFile,
    });
  },
  methods: {
    updateFilteredRooms() {
      // ตรวจสอบเงื่อนไขพื้นฐาน
      if (!this.form.space_needed) {
        console.log("Missing space_needed, setting empty arrays");
        this.filteredFloors = [];
        this.filteredRooms = [];
        return;
      }

      if (
        !this.masterData?.areaMasterRoom ||
        this.masterData.areaMasterRoom.length === 0
      ) {
        console.log("No areaMasterRoom data, setting empty arrays");
        this.filteredFloors = [];
        this.filteredRooms = [];
        return;
      }

      // กรองและตั้งค่า floors
      const matchingRooms = this.masterData.areaMasterRoom.filter((room) => {
        return room.room_type === this.form.space_needed;
      });

      const uniqueFloors = [
        ...new Set(matchingRooms.map((room) => room.floor)),
      ].map((floor) => ({ name: floor, value: floor }));

      this.filteredFloors = uniqueFloors;

      // ถ้าไม่มี floor ที่เลือก ให้ clear rooms
      if (!this.form.space_floor) {
        this.filteredRooms = [];
        return;
      }

      // กรองและตั้งค่า rooms
      const filteredRooms = this.masterData.areaMasterRoom.filter((room) => {
        const matchType =
          room.room_type === this.form.space_needed ||
          room.space_type === this.form.space_needed;
        const matchFloor = room.floor === this.form.space_floor;

        return matchType && matchFloor;
      });

      this.filteredRooms = filteredRooms;

      // หากมีการเลือกห้องแล้ว ให้ update selectedRoomData
      if (this.form.space_room) {
        this.selectedRoomData = this.masterData.areaMasterRoom.find(
          (room) => room.name === this.form.space_room
        );
      }

      this.$forceUpdate();
    },

    placeMarker(x, y) {
      console.log("test x,y", x, y);
      x = Math.floor(Math.random() * 500);
      y = Math.floor(Math.random() * 500);
      let marker = document.getElementById("marker");
      marker.style.left = `${x}px`;
      marker.style.top = `${y}px`;
    },
    setData() {
      this.formFile = this.formData.attachments;
      this.attachment = [];
      this.formData.attachments.forEach((item) => {
        this.attachment.push(item);
      });

      this.$nextTick(() => {
        this.updateFilteredRooms();

        // หากมีการเลือกห้องแล้ว ให้ set selectedRoomData
        if (this.form.space_room && this.masterData?.areaMasterRoom) {
          this.selectedRoomData = this.masterData.areaMasterRoom.find(
            (room) => room.name === this.form.space_room
          );
        }
      });
    },
    addAttachment() {
      this.attachment.push({});
      this.formFile = this.attachment;
      console.log("addAttachment", this.formFile);
    },
    addToAttachment(file, i) {
      console.log("file size", file.size);
      //check if file size > 10mb then show dialog modal
      if (file.size > 50000000) {
        this.$store.commit("General/setModal", {
          title: "ขนาดไฟล์เกิน 50 MB",
          theme: "warning",
          text: "กรุณาแนบไฟล์ที่มีขนาดไม่เกิน 50 MB",
          showCancel: false,
          buttonText: "ตกลง",
        });
        //remove file in to last index of attachment
        this.attachment.pop();
        this.files.pop();
        return;
      }
      this.attachment[i] = file;
      console.log("addToAttachment", this.attachment);
    },
    removeFile(id) {
      this.attachment.splice(id, 1);
      this.files.splice(id, 1);
      this.formFile = this.attachment;
      console.log("removeFile", this.formFile);
    },
    selectFile(id) {
      // querySelector id file จากนั้นเรียก event click
      document.querySelector("#file" + id).click();
    },
    checkValType(val) {
      return typeof val;
    },

    // Handle การเปลี่ยน space_needed
    handleSpaceNeededChange(value) {
      this.form.space_needed = value;

      // รีเซ็ต floor และ room เมื่อเปลี่ยน space_needed
      this.form.space_floor = null;
      this.form.space_room = null;
      this.form.space_area_size = null;
      this.form.area_type_id = null;
      this.selectedRoomData = null;

      // รีเซ็ตค่าอื่นๆ ที่เกี่ยวข้อง
      // this.resetRelatedFields();

      this.$forceUpdate();
      this.updateFilteredRooms();
    },

    // Handle การเปลี่ยน space_floor
    handleSpaceFloorChange(value) {
      this.form.space_floor = value;

      // รีเซ็ต room เมื่อเปลี่ยน floor
      this.form.space_room = null;
      this.form.space_area_size = null;
      this.form.area_type_id = null;
      this.selectedRoomData = null;

      // this.resetRelatedFields();
      this.$forceUpdate();
      this.updateFilteredRooms();
    },

    // Handle การเปลี่ยน space_room
    handleSpaceRoomChange(value) {
      this.form.space_room = value;

      this.selectedRoomData = this.masterData.areaMasterRoom.find(
        (room) => room.name === value
      );

      // Auto-fill ข้อมูลจากห้องที่เลือก
      this.$forceUpdate();
      this.updateFilteredRooms();
      this.autoFillRoomData();
    },

    // Auto-fill ข้อมูลจากห้องที่เลือก
    autoFillRoomData() {
      if (this.selectedRoomData) {
        // ตั้งค่า area size ถ้ามีใน master data
        if (this.selectedRoomData.area_size) {
          this.form.space_area_size = this.selectedRoomData.area_size;
        }

        if (this.selectedRoomData.type) {
          const typeID = this.masterData?.AreaMasterType.find(
            (type) => type.name === this.selectedRoomData.type
          )?.id;

          this.form.area_type_id = typeID;
        }
      }
    },

    // รีเซ็ตฟิลด์ที่เกี่ยวข้อง
    resetRelatedFields() {
      this.form.suggested_max_person = null;
      this.form.available_facilities = null;
      this.form.estimated_price = null;
    },

    getPrefixImageByRegion(region){
      switch(region){
        case 'ภาคตะวันออกเฉียงเหนือ':
          return 'NE1'
        case 'ภาคตะวันออกเฉียงเหนือตอนล่าง':
          return 'NE2'
        default:
          return region;
      }
    },
    handleImageError(event) {
      event.target.src = ""; // เปลี่ยนเป็น URL ของภาพสำรองถ้ามี
      this.selectedRoomData = null; // ตั้งค่า selectedRoomData เป็น null เพื่อแสดงข้อความ No Image
    },
  },
};
</script>

<style>
#marker {
  position: absolute;
  width: 20px;
  height: 20px;
  background-color: red;
  border-radius: 50%;
  transform: translate(-50%, -50%); /* Center the marker */
}
.no-image {
  width: 100%;
  height: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f0f0f0;
  color: #888;
  font-size: 16px;
}
.img-fluid {
  max-width: 100%;
  height: auto;
  object-fit: contain;
}
</style>
